import styles from './charts.module.css'

export type Series = { readonly key: string; readonly label: string; readonly color: string }

export function Legend({ series }: { series: readonly Series[] }) {
  return (
    <ul className={styles.legend}>
      {series.map((s) => (
        <li key={s.key}>
          <span className={styles.swatch} style={{ background: s.color }} aria-hidden="true" />
          {s.label}
        </li>
      ))}
    </ul>
  )
}
